import { useEffect, useState } from 'react'
import { useNavigate, Navigate } from 'react-router'
import { useSelector } from 'react-redux'
import useHttp from '@/shared/hooks/useHttp'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useBusinessType from '@/shared/hooks/useBusinessType'

const CreateForm = () => {
  const [data, setData] = useState(null)
  const navigate = useNavigate()
  const { loaderRoutes, loaderRoutesEnergy, loaderRoutesInsurance, authTokenSession, country } =
    useSelector(selectAuthData)
  const { getApplicationUrl, type: applicationType } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const initUrl = getApplicationUrl('telesales-add') ?? ''
  const token = authTokenSession
  const { sendRequest, getConfig } = useHttp({ token })
  const initialize = params => {
    const search = window.location.search ?? ''
    let countryUrl = initUrl

    if (search) {
      countryUrl += search + '&lang=' + country
    } else {
      countryUrl += '?lang=' + country
    }

    if (params) {
      countryUrl += params
    }

    sendRequest(countryUrl, getConfig('GET'), json => {
      setData(json)
    })
  }

  useEffect(() => {
    //close for french agents
    if (country === 'fr') {
      alert('La création de contrat doit passer par la V2 pour la France.')
      navigate('/' + applicationType)
      return
    }

    initialize()
  }, [])

  if (!data?.id) {
    return <p>Creation du contrat en cours....</p>
  }

  return <Navigate to={'/' + applicationType + '/subscription/edit/' + data.id} />
}

export default CreateForm
